import { render, staticRenderFns } from "./newFriendsSOPList.vue?vue&type=template&id=6b94a060&scoped=true&"
import script from "./newFriendsSOPList.vue?vue&type=script&lang=js&"
export * from "./newFriendsSOPList.vue?vue&type=script&lang=js&"
import style0 from "./newFriendsSOPList.vue?vue&type=style&index=0&id=6b94a060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94a060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b94a060')) {
      api.createRecord('6b94a060', component.options)
    } else {
      api.reload('6b94a060', component.options)
    }
    module.hot.accept("./newFriendsSOPList.vue?vue&type=template&id=6b94a060&scoped=true&", function () {
      api.rerender('6b94a060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/newFriendsSOPList.vue"
export default component.exports